import React from 'react';
import './style.scss';

export type EstablishRadioProps = {
  name: string;
  text: string;
  value: string;
  checked: boolean | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

export const EstablishRadio = (props: EstablishRadioProps) => {
  const { name, text, value, checked, onChange, disabled } = props;

  return (
    <label className="establishRadio">
      <input
        className="establishRadio_input"
        name={name}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="establishRadio_text">{text}</span>
    </label>
  );
};
